import React, { PureComponent } from 'react'
import { Button, Form,Input} from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getData,upData,getDedata } from '../../api/api'
import { getRandomN,URLencode } from '../../utils/tool'

@observer
class Home extends PureComponent {
	@observable dataInfo = ''

	componentDidMount(){
		this.loadData()
	}

	loadData = () =>{
		const param = {
			trxCode:'410010',
			mbrCode:'0045100002126365'
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
			// upData(URLencode(res.data)).then(res =>{
			// 	getDedata(res).then(res =>{

			// 	})
			// })
		})
	}

	render() {
		const { dataInfo } = this
		return (
			<div className="page_content">
				<Form method='post' action='https://lcg.murongtech.com/bhdep/payTransactionNew' style={{display:'none'}} >
                    <Input type='text' name='INFO' value={dataInfo? dataInfo[0].substring(5):''}/>
                    <Input type='text' name='BODY' value={dataInfo? dataInfo[1].substring(5):''}/>
                    <Input type='text' name='SIGN' value={dataInfo? dataInfo[2].substring(5):''}/>
                    <Input type='text' name='CONTENTTYPE' value='json'/>
                    <Input type='submit' value='提交' />
                </Form>
			</div>
		)
	}
}
export default Home
